import { render, staticRenderFns } from "./OnlineExhibitionDetail.vue?vue&type=template&id=30f971f6&scoped=true&"
import script from "./OnlineExhibitionDetail.vue?vue&type=script&lang=js&"
export * from "./OnlineExhibitionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f971f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
